import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const FilterIcon = React.memo(function FilterIcon(props: TFilterIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Filter" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 6.5C3 6.08579 3.33579 5.75 3.75 5.75H18.25C18.6642 5.75 19 6.08579 19 6.5C19 6.91421 18.6642 7.25 18.25 7.25H3.75C3.33579 7.25 3 6.91421 3 6.5ZM5.5 11C5.5 10.5858 5.83579 10.25 6.25 10.25H15.75C16.1642 10.25 16.5 10.5858 16.5 11C16.5 11.4142 16.1642 11.75 15.75 11.75H6.25C5.83579 11.75 5.5 11.4142 5.5 11ZM9.25 14.75C8.83579 14.75 8.5 15.0858 8.5 15.5C8.5 15.9142 8.83579 16.25 9.25 16.25H12.75C13.1642 16.25 13.5 15.9142 13.5 15.5C13.5 15.0858 13.1642 14.75 12.75 14.75H9.25Z"
            />
        </IconBase>
    );
});

export default FilterIcon;

// #region Types

export type TFilterIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <FilterIcon /> : { ...IconBaseExample, render: FilterIcon };

// #endregion
